<div class="wait-ckyc-main" *ngIf="!universalShampoo">
  <div class="row" *ngIf="!isWaitingTime && isCustomerDetails">
    <div class="col-12 text-center">
      <img
        src="assets/gif/verification.gif"
        class="verification-gif-image"
        alt="close"
      />
    </div>
    <div class="col-12">
      <p class="text-center wait-ckyc-text">
        <span class="wait-text-font">Please wait a few minutes for the</span>
        <br />
        <span class="verification-text-font"
          ><strong>CKYC Verification</strong> to be completed</span
        >
      </p>
    </div>
  </div>

  <div class="row" *ngIf="isWaitingTime && isCustomerDetails">
    <div class="col-12">
      <p class="review-fetch-text">
        Please review the data we have fetched after CKYC Verification
      </p>
    </div>
    <div class="ckyc-data">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-6 d-grid">
          <span class="details-header">Full Name</span>
          <span class="details-value">{{
            ckycData["full_name"] ? ckycData["full_name"] : "-"
          }}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-6 d-grid">
          <span class="details-header">Gender</span>
          <span class="details-value">{{
            ckycData["gender"] ? ckycData["gender"] : "-"
          }}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-6 d-grid">
          <span class="details-header">Date of Birth</span>
          <span class="details-value">{{
            ckycData["dob"] ? ckycData["dob"] : "-"
          }}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-6 d-grid mt-1">
          <span class="details-header">Owner Type</span>
          <span class="details-value">{{
            proposerType ? proposerType : "-"
          | titlecase }}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-6 d-grid mt-1">
          <span class="details-header">Contact Number</span>
          <span class="details-value">{{
            ckycData["mobile_number"] ? ckycData["mobile_number"] : "-"
          }}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-6 d-grid mt-1">
          <span class="details-header">Email</span>
          <span class="details-value">{{
            ckycData["email"] ? ckycData["email"] : "-"
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 proceed-btn">
      <button
        class="submit-btn"
        type="submit"
        (click)="onProceedData(ckycData)"
      >
        Proceed
      </button>
    </div>
  </div>
  <div *ngIf="isWaitingTime && !isCustomerDetails">
    <div mat-dialog-title>
      <div class="success-popup-header d-flex justify-content-end">
        <img
          src="assets/icon/cross.svg"
          (click)="onClose(ckycData)"
          class="cursor-pointer"
          alt="close"
        />
      </div>
    </div>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <div>
            <img
              src="assets/gif/error.gif"
              class="error-gif-image"
              alt="close"
            />
            <p class="text-orange">ATTENTION</p>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <div class="me-1">
            <p class="text-content">
              {{ ckycBody["document_type"].split("_")[0] | uppercase }}
              {{ ckycBody["document_type"].split("_")[1] | uppercase }}
            </p>
          </div>
          <div class="ms-3">
            <p class="text-content document-number">
              {{ ckycBody["document_number"] }}
            </p>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <p class="text-content">
            {{ error_message }}
          </p>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <button
            class="submit-btn success-submission"
            type="submit"
            (click)="!loader && redirectInsurer(redirectionUrlViaForm)"
          >
            <img
              src="assets/gif/button-loader.gif"
              alt="close"
              class="loader me-2"
              *ngIf="loader"
              [ngClass]="'isProceedDisabled'"
              :loader
            />
            Proceed
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="universalShampoo">
  <div mat-dialog-title class="d-flex justify-content-between">
    <div>
      <span class="sompo-title">Click on the close button when CKYC is completed (during CKYC process)</span>
    </div>
    <div class="success-popup-header">
      <img
        src="assets/icon/cross.svg"
        (click)="sompoCkycDetails()"
        class="cursor-pointer"
        alt="close"
      />
    </div>
  </div>
</div>

